import FormB2B from "./FormB2B";
import { SELECTORS_FORM_POS as SELECTORS } from "./Constants";
import { IncomingPurchaseRequest } from "./Data";

export class FormPOS extends FormB2B {
    /**
     * prepare form data
     * @param { FormData } formData
     * @return IncomingPurchaseRequest
     */
    prepareFormData(formData: FormData): IncomingPurchaseRequest {
        const repairs: string[] = [];
        formData.forEach((value, key: keyof IncomingPurchaseRequest) => {
            const match = key.match(/repairs\[([^\]]*)]/);
            if (match) {
                repairs.push(match[1]);
            }
        });
        formData.forEach((value, key: keyof IncomingPurchaseRequest) => {
            const match = key.match(/repairs\[([^\]]*)]/);
            if (match) {
                formData.delete(key);
            }
        });
        formData.set("repairs", repairs.join(", "));
        const peEk = formData.get("pe_ek");
        const peVk = formData.get("pe_vk");

        const data = super.prepareFormData(formData);

        data["pe_ek"] = String(peEk).replace(".", "");
        data["pe_vk"] = String(peVk).replace(".", "");
        return data;
    }
}

const form = document.querySelector(SELECTORS.form) as HTMLFormElement;
if (form) {
    new FormPOS(form);
}
